import React, {useState} from "react";
import Modal from 'react-awesome-modal'
import './login-popup.styles.scss'
import MtmInputText from "../../components/mtm-input-text/mtm-input-text.component";
import MtmButton from "../../components/mtm-button/mtm-button.component";
import { addError, removeErrorConfirm, validateEmail } from "../../utils/generaFunctions";
import { getInfo } from "../../utils/recurly.functions";
import { GeneralContext } from "../../contexts/general.context";
import { useContext } from "react";
import { useEffect } from "react";

export const LoginPopup = (props) => {
    const [visible, setVisible] = useState(props.visible);
    const [email, setEmail] = useState("");
    const {loading, setLoading} = useContext(GeneralContext);
      window.setLoginWindow = (stateObject) => {
        if(stateObject){
            document.getElementsByClassName("my-account-container")[0].style.filter = "blur(8px)";
        }
        setVisible (stateObject);
      }
      window.imageVisible = () => {
        return visible;
      }
      useEffect(()=>{
        setLoading(false);
      },[setLoading])
      
      const handleSubmit = () => {
        setLoading(true)
        if(validateEmail(email)){
            getInfo(email).then((resp)=>{
                if(resp.active || resp.pause){
                    if(window.location.search.length > 0){
                        window.location.href = window.location.href + "&email=" + encodeURIComponent(email) + "&address=" + resp.address['country'] + "," + resp.address['state'];
                    } else {
                        window.location.href = window.location.href + "?email=" + encodeURIComponent(email) + "&address=" + resp.address['country'] + "," + resp.address['state'];
                    }
                }else {
                    setLoading(false);
                    addError(document.getElementById("email").parentElement, "NO ACTIVE SUBSCRIPTION WAS FOUND FOR THIS EMAIL");
                }
            }).catch(()=>{
                setLoading(false);
            })
        } else {
            addError(document.getElementById("email").parentElement, "Email not valid");
            setLoading(false);
        }
      }
    return (
        <div className="modal-container"> 
        <Modal visible={visible} effect="fadeInUp" onClickAway={() => {}}>
            <div className={`login-popup-container ${loading?"loading":""}`}>
                <div className="title">
                    <img className="box-image" src={require("../../imgs/box_big.png")} alt="pic-popup"></img>My Account
                </div>
                <div className="contents" style={{gap:"1"}}>
                    <div className="text">Please login with the email that was used to purchase your Miss To Mrs Box Subscription</div>
                    <MtmInputText id="email" name="email" value={email} label="Email" onChange={(e)=> {setEmail(e.target.value); removeErrorConfirm()}} autoComplete="email"></MtmInputText>
                    <MtmButton text="log in" sx={{height:"44px", marginTop:"0", width:"144px"}} onClick={handleSubmit}></MtmButton>
                </div>
            </div>
        </Modal>
        </div>
    )
}